import { inject } from "@angular/core";
import { CanActivateFn } from "@angular/router";
import { OidcSecurityService } from "angular-auth-oidc-client";
import { map } from "rxjs";

// Module-level flag — resets on every full page load (new JS context).
// Set by the guard when it initiates a login redirect so that
// UserInfoService.authorize() can skip its own redundant redirect.
let _guardLoginInitiated = false;

export function isGuardLoginInitiated(): boolean {
    const value = _guardLoginInitiated;
    _guardLoginInitiated = false;
    return value;
}

export const authGuard: CanActivateFn = (_route, _state) => {
    const oidc = inject(OidcSecurityService);

    // Use checkAuth() instead of isAuthenticated$ to ensure stored tokens
    // are validated before deciding. Avoids a race condition on first page
    // load where isAuthenticated$ emits false before initialization completes.
    return oidc.checkAuth().pipe(
        map(({ isAuthenticated }) => {
            if (isAuthenticated) {
                return true;
            }

            _guardLoginInitiated = true;

            const impersonate = sessionStorage.getItem("impersonate");
            if (impersonate != null) {
                oidc.authorize(undefined, {
                    customParams: { acr_values: `impersonate:${impersonate}` }
                });
            } else {
                oidc.authorize();
            }

            return false;
        })
    );
};
